module.exports = {
	'通用':{
		'实时监控':"Real time monitoring",
		'实时定位':'Real time positioning',
		'实时定位2D':'Real time positioning 2D',
		'实时定位2.5D':'Real time positioning 2.5D',
		'实时追踪':'Real time tracking',
		'实时追踪2.5D':'Real time tracking 2.5D',
		'风险分区':'High risk area',
		'风险分区2D':'High risk area 2D',
		'风险分区2.5D':'High risk area 2.5D',
		'热力图':'Heatmap',
		'热力图2D':'Heatmap 2D',
		'热力图2.5D':'Heatmap 2.5D',
		'轨迹查询':'Tracking History',
		'人员轨迹':'Personnel tracking history',
		'车辆轨迹':'Vehicle tracking history',
		'报警管理':'Alert management',
		'人员报警记录':'Personnel Alert Records',
		'车辆报警记录':'Vehicle Alert Records',
		'人员管理':'Personnel management',
		'员工管理':'Employee Management',
		'访客管理':'Visitor Management',
		'承包商管理':'Contractor Management',
		'人员列表':'List of Personnel',
		'设备管理':'Device management',
		'定位卡管理':'Tag Management',
		'信标管理':'Beacon Management',
		'信标管理2D':'Beacon Management 2D',
		'信标管理2.5D':'Beacon Management 2.5D',
		'基站管理':'Base station management',
		'基站管理2D':'Base station management 2D',
		'基站管理2.5D':'Base station management 2.5D',
		'楼宇管理':'Building management',
		'楼层管理':'Floor management',
		'摄像头管理':'CCTV management',
		'摄像头管理2D':'CCTV management 2D',
		'摄像头管理2.5D':'CCTV management 2.5D',
		'车辆卡管理':'Vehicle management',
		'车辆通行记录':'Vehicle travel log management',
		'围栏管理':'Fencing management',
		'电子围栏':'Geofencing',
		'电子围栏2D':'Geofencing 2D',
		'电子围栏2.5D':'Geofencing 2.5D',
		'人员报警设置':'Personnel Alert Settings',
		'车辆报警设置':'Vehicle Alert Settings',
		'报警通知设置':'Alert Notification Settings',
		'SOS报警通知设置':'SOS Alert Notification Settings',
		'区域管理':'Area management',
		'区域列表':'List of areas',
		'重大风险分区管理':'High risk areas management',
		'单区列表':'List of zones',
		'统计管理':'Statistics management',
		'人员统计':'Personnel statistics',
		'》人员统计':'》Personnel statistics',
		'报警统计':'Alert statistics',
		'二道门进出记录':'Door access records',
		'考勤记录':'Attendance records',
		'人员分布统计':'Staff distribution statistics',
		'人员分布统计2.5D':'Staff distribution statistics 2.5',
		'智能巡检':'Intelligent inspection',
		'巡检项管理':'Inspection item management',
		'巡检点管理':'Inspection point management',
		'巡检类别管理':'Inspection type management',
		'巡检班组管理':'Inspection team management',
		'巡检路线管理':'Inspection route management',
		'巡检记录':'Inspection records',
		'隐患管理':'Hazard management',
		'巡检统计':'Inspection statistics',
		'作业安全':'Work safety',
		'JSA作业安全分析':'JSA work safety analysis',
		'作业活动预约':'Work appointment',
		'待办审批':'Pending approval',
		'作业列表':'List of work',
		'作业管理库':'Work management',
		'作业字典管理':'Work vocabulary management',
		'作业配置管理':'Work configuration management',
		'作业审批库':'Work approval library',
		'风险识别管理':'Risk identification management',
		'安全措施管理':'Safety measures management',
		'应急措施管理':'Emergency management',
		'JSA分析库':'JSA analysis management',
		'作业监护':'Work monitoring',
		'AI智能分析设备':'AI intelligent analysis devices',
		'监控设备管理':'CCTV device management',
		'监控报警记录':'CCTV alert records',
		'权限管理':'Authority management',
		'菜单管理':'Menu management',
		'角色管理':'User type management',
		'用户管理':'Account management',
		'部门管理':'Department management',
		'岗位管理':'Job Position management',
		'系统管理':'System management',
		'地图配置':'Map configuration',
		'系统信息':'System message',
		'字典管理':'Vocabulary management',
		'系统配置':'System settings',
		'大屏配置':'Screen settings',
		'登录日志':'Login records',
		'操作日志':'Operating records',
		'版本日志':'Version records',
		'智能灯控':'智能灯控',
		'灯具管理':'灯具管理',
		'灯组管理':'灯组管理',
		'时控任务':'时控任务',
		'灯具功耗统计':'灯具功耗统计',
		'智能灯具':'Intelligent lamps',
		'演练计划':'Drill plan',
		'演练记录':'Drill records',
		'区域进出记录':'Area access records',
		'全员':'All',
		'请输入车辆名称':'Vehicle Name',
		'单区选择':'Zone Selection',
		'单区名称':'Name of zone',
		'不能为空':'Input is required',
		'员工登录':'User login',
		'管理员登录':'Admin login',
		'登录':'Login',
		'记住密码':'Remember password',
		'换一张':'Change',
		'搜索姓名、卡号':'Search for name or ID no.',
		'请输入要查询的车辆':'Search for name or tag no.',
		'请选择部门':'Select Department',
		'选择部门':'Select Department',
		'选择报警类型':'Select type of alert',
		'选择处理状态':'Select status',
		'开始日期':'Start date',
		'结束日期':'End date',
		'人员姓名':'Name.',
		'请输入工号':'Employee ID No.',
		'籍贯':'Nationality',
		'健康状态':'Health status',
		'民族':'Race',
		'出生日期':'Date of birth',
		'政治面貌':'Political Inclination',
		'员工类别':'Type of personnel',
		'证件号码':'ID no.',
		'所属部门':'Department',
		'婚姻状态':'Marital status',
		'所属岗位':'Position',
		'入职日期':'Work start date',
		'职称':'Title',
		'最高学位':'Highest qualification',
		'职称证书编号':'Job certificate number',
		'最高学历':'Highest certification',
		'工龄':'Length of service',
		'专业':'Profession',
		'办公电话':'Office phone no.',
		'毕业证书号':'Graduation certificate number',
		'毕业院校':'Graduate school',
		'3年以上化工行业经验':'3 years and above of experience in the chemical industry',
		'注册工程师证编号':'Engineer registration ID',
		'工作职责':'Work responsibilities',
		'工作经历':'Work experience',
		'照片':'Photos',
		'附件':'Attachments',
		'男':'Male',
		'女':'Female',
		'是':'Yes',
		'否':'No',
		'选择日期':'Select Date',
		'接待人联系方式':"Receptionist's telephone",
		'来访单位':'Company name',
		'请输入单位名称':'Company name',
		'法人':'Company representative',
		'经营范围':'Scope of works',
		'营业执照':'Business License',
		'请选择人员类型':'Select type of personnel',
		'请输入电量值':'Battery life',
		'二道门状态':'Gate status',
		'进入':'entry',
		'离开':'leave',
		'请输入定位卡号':'Tag No.',
		'请选择使用状态':'Select status',
		'请选择启用状态':'Select activation status',
		'请选择定位卡类型':'Select type of tag',
		'请输入IC卡号':'IC No.',
		'定位卡':'Card tag',
		'智能手表':'Smartwatch',
		'请输入信标编码':'Beacon No.',
		'全部':'All',
		'请输入基站编码':'Base Station No.',
		'请选择基站类型':'Select type of base station',
		'基站编码':'Base Station No.',
		'基站类型':'Type of base station',
		'端口号':'Port No.',
		'请输入楼宇名称':'Building Name',
		'经度':'Latitude',
		'纬度':'Longitude',
		'高度':'Height',
		'楼宇名称':'Building Name',
		'请输入楼层名称':'Floor Name',
		'楼层名称':'Floor Name',
		'地图类型':'Type of Map',
		'文件':'Document',
		'楼层简称':'Floor Name Abbreviation',
		'移速（米/秒）':'Speed (m/s)',
		'最大经度':'Largest latitude',
		'最小经度':'Smallest latitude',
		'最大纬度':'Largest latitude',
		'最小纬度':'Smallest longitude',
		'视角高度':'Height',
		'工具':'Tools',
		'设置':'Settings',
		'通过工具绘制区域会自动取出绘制区域的最大最小坐标和视角高度':'Use the drawing tool to automatically extract the coordinates and height of the floor area',
		'请输入摄像头名称':'CCTV Name',
		'请输入所属楼层':'Floor',
		'请输入ip地址':'IP Address',
		'摄像头名称':'CCTV Name',
		'RTSP流地址':'RTSP Address',
		'ip地址':'IP Address',
		'所属楼层':'Floor',
		'请输入车辆编码':'Vehicle Code',
		'请输入车牌号':'Vehicle Plate No.',
		'请输入司机姓名':'Driver Name',
		'请输入SN码':'SN No.',
		'车辆编码':'Vehicle Code',
		'SN码':'SN No.',
		'车辆名称':'Vehicle Name',
		'车辆类型':'Vehicle Type',
		'车牌号':'Vehicle Plate No.',
		'限速（Km/h）':'Speed limit (km/h)',
		'司机姓名':'Driver Name',
		'司机手机号':'Driver Phone No.',
		'设备状态':'Status',
		'记录时间':'Record Time',
		'请输入围栏名称':'Name',
		'围栏名称':'Name',
		'当前位置':'Current Selection',
		'请输入报警设置名称':'Alert subject',
		'请选择报警类型':'Alert type',
		'围栏':'Geofencing area',
		'例外人员':'Exempted Personnel',
		'报警通知':'Alert subject',
		'生效日期':'Effective date',
		'生效时间':'Effective time',
		'报警规则（秒/人）':'Alert control (s/person)',
		'绑定车辆':'Fixed vehicles',
		'报警通知名称':'Alert Notification Subject',
		'通知类型':'Alert type',
		'一级接收者人员':'Level 1 recipient',
		'二级接收者人员':'Level 2 recipient',
		'三级接收者人员':'Level 3 recipient',
		'是否启用':'Activation',
		'第一时间接收到信息':'Receive notification immediately',
		'请设置':'Receive notification after',
		'分钟后接收到信息':'minutes',
		'短信通知':'SMS notification',
		'报警通知提示':'Reminder',
		'报警通知提示内容':'If the alert status is set to “processed”, no further notifications will be sent; If the alert status is set to “not processed”, notifications will be sent according to the settings',
		'请填写区域名称':'Name of area',
		'今日人员数据概览':'Personnel Overview (Today)',
		'人':'pax',
		'较昨日':'Yesterday',
		'较上周同日':'Last week',
		'人员流量数据统计':'Personnel Traffic Statistics (Today)',
		'员工占比':'Employee statistics',
		'在线':'online',
		'离线':'offline',
		'绑定':'linked',
		'解绑':'Unbind',
		'未绑定':'unlinked',
		'近7天':'Recent 7 days',
		'近30天':'Recent 30 days',
		'次':'times',
		'今日报警数据概览':'Alert Overview (Today)',
		'高发报警区域统计':'High alert area statistics',
		'报警人员统计':'Personnel alert statistics',
		'报警类型统计':'Alert type statistics',
		'报警数量走势图':'Total no. of alerts chart',
		'时间段查询':'Time period',
		'位置':'Position',
		'进出类型':'Entrance & exit type',
		'类型':'Type',
		'打卡时间':'Check in time',
		'请输入巡检项名称':'Inspection item',
		'巡检项内容':'Inspection item',
		'参数名称':'Device parameters',
		'阈值（下限）':'Threshold (lower limit)',
		'阈值（上限）':'Threshold (upper limit)',
		'单位':'Unit',
		'添加设备参数':'Add Parameter',
		'请输入巡检点名称':'Inspection point',
		'巡检点名称':'Inspection point',
		'巡检点编码':'Inspection point no.',
		'巡检点类型':'Inspection point type',
		'所属区域':'Area',
		'巡检点状态':'Inspection point status',
		'负责人':'Person in charge',
		'经纬度':'Latitude & longitude',
		'定位点':'Location',
		'巡检点查看':'Search inspection points',
		'关联巡检项':'Associated inspection items',
		'请输入巡检类别名称':'Inspection type',
		'巡检类别':'Inspection type',
		'检查方式':'Inspection method',
		'检查内容':'Inspection item',
		'依据':'Compliance',
		'请输入巡检班次名称':'Inspection shift',
		'巡检班次名称':'Inspection shift',
		'巡检组长':'Inspection team leader',
		'巡检人员':'Inspection personnel',
		'开始时间':'Start time',
		'结束时间':'End time',
		'巡检路线名称':'Inspection route',
		'巡检点':'Inspection point',
		'巡检周期':'Inspection period',
		'巡检时间':'Inspection time',
		'巡检班组':'Inspection group',
		'巡检负责人':'Person in charge',
		'新增巡检点':'New inspection point',
		'添加巡检时间':'New inspection time',
		'*注:可通过拖拽巡检点改变顺序。':'*Note: drag and drop to rearrange the order of inspection points',
		'任务状态':'Task status',
		'巡检状态':'Inspection status',
		'巡检人':'Inspector',
		'巡检点数':'Inspection points',
		'完成点数':'Completed points',
		'隐患数量':'No. of hazards',
		'隐患状态':'Hazard status',
		'隐患上传时间':'Hazard upload time',
		'添加安全分析':'Add safety analysis',
		'安全分析':'Safety analysis',
		'查看':'Preview',
		'请输入JSA编码':'JSA no.',
		'请选择作业单位':'Work unit',
		'请输入分析组长':'Analysis team leader',
		'JSA编码':'JSA no.',
		'作业单位':'Work unit',
		'作业日期':'Work date',
		'作业地点':'Work location',
		'作业内容':'Work description',
		'JSA安全分析':'JSA safety analysis',
		'分析组长':'Analysis team leader',
		'分析组员':'Analysis team member',
		'作业环节':'Work procedure',
		'风险内容':'Risk description',
		'风险结果':'Risk outcome',
		'安全措施':'Mitigation measure',
		'JSA组织人':'JSA组织人',
		'请选择作业申请人':'Work Applicant',
		'请输入预约单号':'Appointment number',
		'预约单号':'Appointment number',
		'预约作业时间':'Appointment time',
		'申请单位':'Department',
		'作业申请人':'Work Applicant',
		'作业申请':'Work Applicant',
		'作业监护人':'Work supervisor',
		'作业方':'Operator',
		'现场联系人':'Contact person',
		'现场联系电话':'Contact',
		'作业级别':'Work level',
		'申请作业票':'Apply work ticket',
		'申请票号':'Application No.',
		'作业名称':'Work Description',
		'涉及其它作业':'Affects other works',
		'JSA分析':'JSA analysis',
		'作业开始时间':'Start date',
		'作业结束时间':'End date',
		'申请人':'Applicant',
		'申请状态':'Application status',
		'编辑':'Edit',
		'提交':'Submit',
		'开始':'Start',
		'默认':'Default',
		'流程结束':'End',
		'审批名称':'Approval',
		'属性':'Characteristic',
		'作业票号':'Work No.',
		'申请时间':'Application time',
		'审批流程':'Approval process',
		'作业票状态':'Work ticket status',
		'确认角色':'Role confirmation',
		'字典类型':'Vocabulary type',
		'标签':'Tag',
		'值':'Value',
		'排序':'Sort',
		'是否默认':'Default status',
		'作业时间不能超过':'Working hours cannot exceed',
		'小时（最大72小时）':'hours (max 72 hours)',
		'现场分析应在作业开始前':'Site analysis to begin',
		'分钟执行（最大60分钟）':'mins before work (max 60mins)',
		'安全措施内容':'Safety measures description',
		'应急措施内容':'Emergency description',
		'设备ID':'Device id',
		'推送服务器地址':'Push server address',
		'推送服务器端口':'Push server port',
		'推送服务器验证':'Push server verification',
		'GPU':'GPU',
		'视频分析设备':'Video analysis device',
		'编号':'Device No.',
		'名称':'Device Name',
		'端口':'Port',
		'流协议类型':'Type of streaming protocol',
		'视频流地址':'Streaming protocol address',
		'摄像头账号':'Camera ID',
		'摄像头密码':'Camera password',
		'分辨率':'Resolution',
		'识别算法':'Identification algorithm',
		'间隔时间（S）':'Interval (s)',
		'视频流path':'Streaming protocol path',
		'分析设备':'Analysis device',
		'监控名称':'CCTV name',
		'报警图片':'Alert photo',
		'报警视频':'Alert video',
		'销警时间':'Alert response time',
		'销警反馈':'Alert response remarks',
		'销警人':'Alert responder',
		'销警':'Alert response',
		'菜单名称':'Menu name',
		'菜单类型':'Menu type',
		'路由类型':'Route type',
		'显示顺序':'Display order',
		'描述':'remarks',
		'目录':'contents',
		'菜单':'Menu',
		'按钮':'Button',
		'路由':'Route',
		'图标':'Icon',
		'路由地址':'Route path',
		'角色名':'User type',
		'权限字符':'User name',
		'权限配置':'User config',
		'菜单权限':'Menu config',
		'App授权':'App config',
		'登录名':'Login username ',
		'角色':'User type',
		'重置密码':'Reset password',
		'绑定人员':'Link tag to personnel',
		'人员批量注册':'Register personnel',
		'部门ID':'Department ID',
		'电话':'Contact no.',
		'邮箱':'Email',
		'岗位名':'Job position',
		'岗位职责':'Job responsibilities',
		'演练名称':'Name of drill',
		'演练日期':'Drill date',
		'评审人员':'Reviewers',
		'演练过程记录':'Drill records',
		'演练效果评价':'Drill evaluation',
		'参与描述':'Participation description',
		'模型':'Model',
		'倾斜':'Tilt',
		'地图地址':'Map address',
		'经度/X偏移':'Longitude/x offset',
		'纬度/Y偏移':'Latitude/y offset',
		'高度/Z偏移':'Height/z offset',
		'是否拖动':'Drag and drop',
		'点击经度':'Select longitude',
		'点击纬度':'Select latitude',
		'加载地图':'Load map',
		'保存配置':'Save settings',
		'取消':'Cancel',
		'系统信息管理':'System message',
		'系统名称':'System name',
		'LOGO':'LOGO',
		'底图类型':'Base map type',
		'默认路由':'Default path',
		'3D':'3D',
		'2.5D':'2.5D',
		'2D':'2D',
		'地图范围':'Map range',
		'绘制':'Edit',
		'置空':'Reload',
		'保存并刷新':'Save',
		'关闭':'Close',
		'天地图':'Map world',
		'WMTS在线服务':'WMTS online service',
		'配置名称':'Settings',
		'配置值':'Settings value',
		'登录用户':'Login account',
		'登录状态':'Login state',
		'终端地址':'Terminal address',
		'操作人':'Operator',
		'操作时间':'Operating time',
		'操作名称':'Operation',
		'请求方式':'Request method',
		'请求方法':'Request method',
		'返回结果':'Return result',
		'操作状态':'Operation state',
		'客户端地址':'client end address',
		'3D阴影':'3D shadow',
		'系统语言':'System language',
		'打开':'Open',
		'进':'In',
		'出':'Out',
		'星期一':'Monday',		
		'星期二':'Tuesday',		
		'星期三':'Wednesday',		
		'星期四':'Thursday',		
		'星期五':'Friday',		
		'星期六':'Saturday',		
		'星期日':'Sunday',		
		'全厂人数':'Total no. of personnel',
		'楼层选择':'Layer Select',
		'灯具':'Lamps',
		'监控':'Monitoring',
		'重大风险分区':'High risk areas',
		'人员类别统计':'Personnel Statistics',
		'人员类别环比':'Personnel Comparison',
		'部门统计':'Department Statistics',
		'重大风险分区统计':'High risk area statistics',
		'区域统计':'Area statistics',
		'批量处理报警记录':'Alert records',
		'报警类别':'Type of alert',
		'报警内容':'Description',
		'新增员工':'New employee details',
		'查看员工':'View employee details',
		'编辑员工':'Edit employee details',
		'导入员工':'Import Employee Details ',
		'新增访客':'New visitor details',
		'编辑访客':'Edit visitor details',
		'查看访客':'View visitor details',
		'导入访客':'Import visitor details',
		'新增信息':'New details',
		'编辑信息':'Edit details',
		'查看信息':'View details',
		'导入信息':'Import details',
		'新增区域':'New area',
		'个人设置':'Personal settings',
		'服务器配置':'Server Configuration',
		'换肤':'Skin peeler',
		'退出登录':'Logout',
		'灯具实时分析':'Real-time Lamps Statistics',
		'总数':'Total',
		'熄灯':'Lights out',
		'亮灯':'Light up',
		'掉电':'Power down',
		'在线人数':'No. of people online',
		'人员':'Personnel',
		'摄像头':'CCTV',
		'地图':'Map',
		'列表':'List',
		'全屏':'Full screen',
		'车辆':'Vehicle',
		'序列':'No.',
		'部门名称':'Department',
		'日期':'Date',
		'人数':'No. of People',
		'未处理':'Not processed',
		'SOS报警':'SOS',
		'人员、车辆实时分析':'Personnel and Vehicles Statistics',
		'部门实时分析':'Real-time Department Statistics',
		'人员周统计':'Weekly Personnel Statistics',
		'今日人员报警':'Personnel Alerts Today',
		'人员报警':'Personnel Alerts',
		'今日车辆报警':'Vehicle Alert Today',
		'车辆报警':'Vehicle Alert',
		'今日区域报警':'Area Alert Today',
		'区域人员实时分析':'Real-time Area Personnel Statistic',
		'组织人':'Organiser',
		'序号':'No.',
		'单区':'Zone',
		'状态':'Status',
		'分区名称':'Name of Area',
		'总人数':'Total no.',
		'区域名称':'Name of Area',
		'姓名':'Name',
		'卡号':'Tag No.',
		'部门':'Department.',
		'追踪':'Tracking Status',
		'报警时间':'Time of alert',
		'报警类型':'Type of alert',
		'报警位置':'Alert location',
		'报警区域名':'Name of area',
		'报警描述':'Description',
		'定位卡号':'Tag No.',
		'处理状态':'Status',
		'处理反馈':'Remarks',
		'处理时间':'Time of response',
		'处理人':'Person in charge',
		'操作':'Edit',
		'速度':'Speed',
		'性别':'Gender',
		'工号':'Employee ID No.',
		'联系方式':'Contact details',
		'人员类别':'Type',
		'人员状态':'Status',
		'IC卡号':'IC No.',
		'工作单位':'Employer',
		'来访时间':'Time in',
		'离开时间':'Time out',
		'来访状态':'Status',
		'接待人':'Receptionist',
		'单位名称':'Company name',
		'类别':'Type',
		'行业类型':'Industry',
		'联系人':'Contact person',
		'联系电话':'Contact details',
		'是否加入黑名单':'Blacklisted',
		'审批':'Approval',
		'人员类型':'Type of personnel',
		'员工类型':'Employee type',
		'员工状态':'Status',
		'卡类型':'Type of tag',
		'电量':'Battery',
		'在线状态':'Online Status',
		'定位设备类型':'Type of tag',
		'电量（%）':'Battery (%)',
		'电量(%)':'Battery (%)',
		'使用状态':'User state',
		'启用状态':'Activation state',
		'备注':'Remarks',
		'信标编码':'Beacon No.',
		'信标分组':'Beacon group',
		'衰减度':'Rate of attenuation',
		'一米信号强弱':'1m signal strength',
		'传输状态':'Transmission status',
		'启用':'Active',
		'禁用':'Inactive',
		'新增单区':'New zone',
		'大屏展示':'Full screen',
		'取消追踪':'Cancel Tracking',
		'查询':'Search',
		'批量处理':'Edit remarks for all',
		'批量删除':'Delete all',
		'导入':'Import',
		'导出':'Export',
		'确定':'OK',
		'选择文件':'Select',
		'开始导入':'Import',
		'下载模板':'Download template',
		'信标位置管理':'Beacon position management',
		'基站位置管理':'Base Station Position Management',
		'楼宇位置管理':'Building position management',
		'摄像头位置管理':'CCTV position management',
		'返回厂区':'Back Home',
		'添加信标':'Add Beacon',
		'同步':'Sync',
		"二维码":"QR code",
		'下载二维码':'Download QR code',
		'导入提示1':'1、Please import excel documents (.xlsx or .xls) only. The template provided must be strictly adhered to. Sections marked in red must be filled in.',
		'导入提示2':'2、The system will automatically remove repeating, invalid and existing entries.',
		'导入提示3':'3、To prevent errors, please do not import existing data in the system.',
		'账号不能为空':'Account cannot be empty',
		'密码不能为空':'Password cannot be empty',
		'验证码不能为空':'Verification code cannot be empty',
		'应急演练':'Emergency drills',
		'首页':'Homepage', 
		'定位追踪':'Location tracking', 
		'历史轨迹':'Track history', 
		'安全作业':'Safety works',
		'应急救援':'Emergency rescue', 
		'移动电话':'Mobile phone', 
		'身份证号':'ID no.', 
		'离场日期':'Exit date', 
		'职务':'Job title', 
		'创建时间':'Construction time', 
		'完成时间':'Time completed', 
		'身份':'Identity', 
		'签名':'Signature', 
		'巡检结果':'Inspection results', 
		'完成状态':'Completed condition', 
		'巡检完成时间':'Inspection complete time', 
		'巡检反馈':'Inspection feedback', 
		'巡检项状态':'Inspection item status', 
		'采集值':'Acquisition value', 
		'阈值':'Threshold', 
		'采集状态':'Acquisition status', 
		'异常巡检项':'Abnormal inspection status', 
		'审核信息':'Audit information', 
		'整改信息':'Information correction', 
		'验收信息':'Information acceptance',
		'检查项':'Check items',  
		'审核人':'Reviewer', 
		'审核时间':'Review time', 
		'审核值':'Review value', 
		'审核描述':'Review description', 
		'审核结果':'Review result', 
		'审核反馈':'Review feedback', 
		'整改期限':'Rectification period', 
		'整改人':'Rectifier', 
		'整改时间':'Recitification time', 
		'整改值':'Rectification value', 
		'整改措施':'Rectification measures', 
		'整改结果':'Rectification results', 
		'整改反馈':'Rectification feedback',
		'验收人':'Acceptor', 
		'验收时间':'Acceptance time', 
		'验收值':'Acceptance value', 
		'验收情况':'Acceptance status', 
		'验收结果':'Acceptance result', 
		'验收反馈':' Acceptance feedback',
		'作业证类型':'Type of work permit', 
		'请选择':'Please select', 
		'重新选择':'Please select again', 
		'涉及其他作业':'Other works involved', 
		'审批环节':'Approval link', 
		'审批人':'Approver', 
		'作业时间':'Time of works', 
		'作业负责人':'Person in charge of works', 
		'作业负责人手机号':'Phone number for person in charge of works', 
		'上传':'Upload', 
		'动火方式':'Type of hot works', 
		'监护人':'Supervisor', 
		'动火初审人':'Hot works examiner', 
		'作业人员':'Operator', 
		'作业位置':'Operator position', 
		'作业位置签到范围（米）':"Operator's check in range (meters)", 
		'风险识别':'Risk identification',
		'应急措施':'Emergency measures', 
		'作业分析人':'Work analyst', 
		'现场安全确认人':'Safety confirmation officer', 
		'安全交底人':'Safety handover person in charge', 
		'作业验收人':'Work acceptance person in charge', 
		'作业围栏':'Work fence', 
		'绘制围栏':'Draw fence', 
		'离岗报警':'Off duty alert', 
		'围栏人员':'Fence personnel',
		'上一步':'Previous step', 
		'保存':'Save', 
		'保存并进入下一步':'Save and go to the next step', 
		'保存并提交审批':'Save and submit for approval', 
		'请选择JSA分析':'Please select JSA analysis', 
		'作业审批选择':'Job approval selection', 
		'请输入审批名称':'Please enter approval name', 
		'模板':'Template', 
		'其他':'Others',
		'审批部门查看':'Check approval department', 
		'作业管控查看':'Check works control', 
		'作业分析':'Works analysis', 
		'作业审批查看':'Check works approval', 
		'作业信息':'Works information', 
		'现场分析':'On-site analysis', 
		'现场安全确认':'On-site safety confirmation', 
		'作业审批':'Job approval', 
		'作业验收存档':'Job acceptance archive', 
		'签到范围':'Check-in range', 
		'作业电子围栏':'Geofencing works', 
		'围栏报警':'Fencing alert', 
		'申请附件':'Application attachment', 
		'分析记录':'Analysis record', 
		'仪器名称':'Device name', 
		'仪器型号':'Device model',
		'采样点':'Sampling point', 
		'分析内容':'Analyse content', 
		'分析结果':'Analysis results', 
		'正常':'Normal', 
		'异常':'Abnormal', 
		'分析时间':'Analysis time', 
		'分析人':'Analyst', 
		'现场分析人':'On-site analyst',
		'签名时间':'Signature time',
		'存档附件':'Archive attachments', 
		'票证导出':'Export tickets', 
		'结果':'Results', 
		'措施内容':'Prevention measures content', 
		'应急内容':'Emergency content', 
		'审批意见':'Approval comments', 
		'安全交底清单':'Safety disclosure checklist', 
		'接受交底人':'Handover person in charge', 
		'解绑人员':'Unlink personnel', 
		'人员注册':'Personnel registration', 
		'岗位':'Job post', 
		'密码':'Password', 
		'确认密码':'Confirm password', 
		'角色选择':'Select role', 
		'角色配置':'Role settings', 
		'新增用户':'New account', 
		'编辑用户':'Edit account', 
		'修改密码':'Change password', 
		'6-20以上的字母加数字的密码组合':'6-20 password characters with a combination of letters and numbers', 
		'左键拖动地图，鼠标滚轮放大缩小，右键绘制围栏':'Left click to move around the map, scroll to zoom in and zoom out, right click to edit geofencing', 
		'实时演练':'Drill', 
		'未开始':'Not started', 
		'进行中':'In progress', 
		'已结束':'Ended', 
		'已完成':'Completed', 
		'未巡检':'Not inspected', 
		'巡检中':'Inspection in progress', 
		'逾期未完成':'Overdue', 
		'未完成':'Not completed', 
		'出厂':'Factory', 
		'批量绑定':'Bind batch', 
		'批量解绑':'Unbind batch', 
		'参与部门':'Participating department', 
		'演练地点':'Drill location', 
		'集合开始时间':'Start time', 
		'集合结束时间':'End time', 
		'演练状态':'Drill status', 
		'相关部门':'Relevant department', 
		'楼层':'Floor', 
		'参演人数':'Number of participants', 
		'实到人数':'Actual number of participants', 
		'过程记录':'Process record', 
		'演练效果':'Drill effect', 
		'上传附件':'Upload attachment', 
		'集合状态':'Gathering status', 
		'绘制完成':'Finish editing', 
		'其它':'Others', 
		'修改':'Edit', 
		'删除':'Delete', 
		'授权':'Authorise', 
		'强退':'Exit', 
		'生成代码':'Generate code', 
		'清空数据':'Clear data',
		'已处理':'Processed', 
		'在职':'Present', 
		'离职':'Absent', 
		'未离开':'Not departed', 
		'已离开':'Departed', 
		'使用':'Active', 
		'未使用':'Inactive', 
		'无线基站':'Wireless base station', 
		'局域网基站':'LAN base station', 
		'动火作业':'Hot works', 
		'吊装作业':'Hoisting works', 
		'断路作业':'Circuit breaker works', 
		'高处作业':'Working at heights', 
		'设备检修作业':'Equipment maintenance works', 
		'盲板抽堵作业':'Pipeline blinding works', 
		'受限空间作业':'Working at confined spaces', 
		'二级动火作业':'Level 2 hot works', 
		'一级动火作业':'Level 1 hot works', 
		'特殊动火作业':'Special hot works', 
		'三级吊装作业':'Level 3 hoisting works', 
		'二级吊装作业':'Level 2 hoisting works', 
		'一级吊装作业':'Level 1 hoisting works', 
		'三级高处作业':'Level 3 working at heights', 
		'二级高处作业':'Level 2 working at heights', 
		'一级高处作业':'Level 1 working at heights', 
		'特级高处作业':'Special working at heights', 
		'进场日期':'Start date', 
		'通用类型':'Generic type',
		'操作类型':'Type of operation',
		'单位类别':'Type of unit',
		'员工类型-橙':'Type of worker - orange',
		'员工类型-绿工服':'Type of worker - green uniform',
		'证件类型':'Type of ID',
		'单位性质':'Unit specifications',
		'承包商类型':'Type of contractor',
		'行业类别':'Type of industry',
		'学位':'Academic qualifications',
		'学历':'Education background',
		'报警类型设置':'Type of alert settings',
		'巡检类型':' Type of inspection',
		'隐患类型':'Type of hidden risks',
		'车辆报警类型':'Type of vehicle alert',
		'车辆报警类型设置':'Type of vehicle alert settings',
		'员工类型-白':'Type of worker - white',
		'人员识别卡':'Personnel identification card',
		'智能定位手表':'Smart location positioning watch',
		'动土作业':'hot works',
		'本厂':'Current factory',
		'外来方':'Foreign party',
		'电焊':'Welding',
		'气焊（割）':'Gas welding (cutting)',
		'切割':'Cut',
		'电钻':'Electric drill',
		'砂轮':'Grinding wheel',
		'喷灯':'Blow torch',
		'喷砂':'Sandblasting',
		'磨光':'Polish',
		'现场安全交底':'On-site safety disclosure',
		'现场实施':'On-site implementation',
		'作业结束确认':'End of job confirmation',
		'审批中':'Under approval',
		'审批通过':'Approved',
		'已验收存档':'Already archived',
		'已作废':'Out of date',
		'行人检测':'Pedestrian detection',
		'人脸检测':'Facial detection',
		'明火检测':'Fire detection',
		'烟雾检测':'Smoke detection',
		'安全帽检测':'Safety helmet detection',
		'打电话检测':'Call detection',
		'灭火器检测':'Fire extinguisher detection',
		'抽烟检测':'Smoking detection',
		'多人聚集检测':'Crowding detection',
		'人员离岗':'Staff leaving',
		'人员攀爬':'Staff climbing',
		'人员入侵':'Staff breaching',
		'员工':'Personnel',
		'访客':'Visitor',
		'承包商':'Contractor',
		'新增':'Add',
		'供应商':'Supplier',
		'巡检员':'Inspector',
		'安全员':'Security officer',
		'居民身份证':'Resident identity card',
		'军人证':'Military ID',
		'港澳台居民身份证':'Hong Kong, Macao and Taiwan resident ID',
		'华侨身份证':'China resident ID',
		'外籍护照':'Foreign passport',
		'有限责任公司':'Limited liability company',
		'股份有限公司':'Company limited',
		'高处安全作业证':'Working at heights certification',
		'设备检修安全作业证':'Equipment safety and maintenance certification',
		'受限空间安全作业证':'Working in confined spaces certification',
		'盲板抽堵安全作业证':'Pipeline blinding works certification',
		'吊装安全作业证':'Hoisting works certification',
		'动土安全作业证':'Ground breaking works certification',
		'断路安全作业证':'Circuit breaker works certification',
		'准承包商':'Prospective contractor',
		'合格承包商':'Qualified contractor',
		'不合格承包商':'Unqualified contractor',
		'环境改造':'Environment change',
		'工程检修安装':'Overhaul and installation',
		'建筑施工':'Building construction',
		'服务业':'Service industry',
		'农业':'Agriculture industry',
		'建筑业':'Construction industry',
		'化工业':'Chemical industry',
		'制造业':'Manufacturing industry',
		'交通运输':'Transportation',
		'电力燃气':'Electric gas',
		'其它行业':'Other industries',
		'学士':"Bachelor's degree",
		'硕士':"Master's degree",
		'博士':'PhD',
		'小学':'Primary school',
		'初中':'Elementary school',
		'高中':'High school',
		'大专':'College',
		'本科':'Undergraduate',
		'硕士研究生':'Postgraduate',
		'博士研究生':'PhD student',
		'进入报警':'Enter alert',
		'越界报警':'Breaching alert',
		'滞留报警':'Loitering alert',
		'缺员报警':'Absence alert',
		'超员报警':'Overcrowding alert',
		'静止报警':'Standstill alert',
		'巡检路线数':'Number of inspection routes',
		'隐患数':'Number of hidden risks',
		'待审核':'Pending review',
		'待整改':'Pending revision',
		'待验收':'Pending acceptance',
		'无需整改':'No revision needed',
		'逾期未整改':'Overdue revision',
		'验收通过':'Accepted',
		'验收不通过':'Not accepted',
		'未巡检数':'No inspections',
		'存在隐患':'Existing hidden risks',
		'巡检正常':'Normal inspection',
		'未巡检点':'Not inspected',
		'存在隐患点':'Existing hidden risks',
		'正常点':'Normal point',
		'NFC':'NFC',
		'低电报警':'Low battery alert',
		'超速报警':'Speeding alert',
		'汽车':'Car',
		'货车':'Truck',
		'叉车':'Forklift',
		'管理员':'Administrator',
		'消防车':'Firetruck',
		'作业类型':'Job type',
		'作业审批阶段':'Job approval stage',
		'信标默认一米信号强弱':'Default 1m signal strength for beacon',
		'信标默认衰减度':'Default attenuation for beacon',
		'rssi最小有效值':'Minimum valid value for rssi',
		'缓冲N秒采集数据':'N seconds buffer of data acquisition',
		'原始数据保留时间（秒）':'Raw data retention time (seconds)',
		'单点定位有效距离（米）':'Effective distance for single point positioning (meters)',
		'实时定位在线时间（分钟）':'Real-time positioning online time (minutes)',
		'上班考勤信标':'Beacon for check in',
		'下班考勤信标':'Beacon for check out',
		'考勤信标有效距离':'Effective distance of beacon',
		'下线信标':'Offline beacon',
		'视频联动有效距离':'Effective distance of video linkage',
		'进入大于N次才报警':'Alert will be triggered after entering more than N times',
		'小于N米立即移动':'Move immediately if it is less than N meters',
		'小于N米保持不动':'Do not move if it is less than N meters',
		'小于N秒不换楼层':'Do not move to other floors if it is less than N meters',
		'超过N米轨迹不连线':'Track is not connected if it exceeds N meters',
		'超过N秒轨迹不连线':'Track is not connected if it exceeds N seconds',
		'车辆超过N米轨迹不连线':'Vehicle is not connected if it exceeds N meters',
		'车辆超过N秒轨迹不连线':'Vehicle is not connected if it exceeds N seconds',
		'报警监测间隔（分钟）':'Alarm monitoring interval (minutes)',
		'静止报警方式':'Static alarm mode',
		'持续超员时间（秒）':'Duration of overcrowding (seconds)',
		'最高定位模式':'Highest positioning mode',
		'最大移速':'Maximum speed',
		'改变方向时间':'Time to change direction',
		'历史轨迹保留天数':'Number of days historical track is stored',
		'报警部门':'Alert Department',
		'发卡机管理':'Tag charging station management',
		'发卡机记录':'Tag charging station records',
		'设备名称':'Equipment Name',
		'人脸机URL':'Facial recognition machine URL',
		'人脸机用户名':'Facial recognition machine username',
		'人脸机密码':'Facial recognition machine password',
		'发卡机SN':'Tag charging station SN number',
		'人脸相机':'Facial recognition  camera',
		'设备位置':'Equipment location',
		'设置为人脸相机':'Equipment is a facial recognition camera',
		'柜号':'Cabinet number',
		'成功':'success',
		'失败':'fail',
		'发卡':'issued',
		'还卡':'returned',
		'车辆追踪':'Vehicle tracking',
		'实时追踪2D':'Real time tracking 2D',
		'搜索SN码-车辆名称':'Search for SN no. or vehicle name',
		'车辆SN':'Vehicle SN',
		'IP地址':'IP address',
		'监测时间':'Monitoring time',
		'请选择传输状态':'Please select transmission status',
		'记录类型':'Type of records',
		'选择记录类型':'Select type of records',
		'分组名称':'Group name',
		'请填写分组名称':'Install group name',
		'新增信标分组':'New group',
		'信标分组配置':'Beacon group settings',
		'开始绘制':'Start drawing',
		'重置':'Reset',
		'返回':'Return',
		'（鼠标右键绘制电子围栏，需首尾相连）':'(Right click to draw the geofencing area, start and end should be connected)',
		'编号开关':'Beacon No. ',
		'信标显示':'Beacon display',
		'信标分组显示':'Beacon group display',
		'》信标分组配置':'Beacon group settings',
		'统计分析':'Inspection statistics',
		'巡检路线走势图':'Inspection route chart',
		'通过两个参考坐标取出最大最小经纬度':'The maximum and minimum latitude and longitude are extracted from the two reference coordinates',
		'查看示例':'Examples',
		'注：请将地图多余面积裁剪后再上传计算':'Tips: Please cut the excess area of the map and upload it for calculation',
		'全景图':'panorama',
		'楼层图':'Floor',
		'绘制区域':'Draw area',
		'参考点方式':'Reference point',
		'如:2F(尽可能简短将显示于定位)':'Such as 2F(as short as possible will be displayed in the location)',
		"承包商作业人员管理":"Management of Contractor's operating personnel",
		"》承包商作业人员管理":"》Management of Contractor's operating personnel",
		"手机号":"Phone No.",
    	"岗位名称":"Post Name",
    	"承包商名称":"contractor name",
    	"分类":"classification",
    	"统一社会信用代码":"Unified social credit code",
    	"行业":"industry",
    	"承包商类别":"Category of Contractor",
    	"安全负责人":"Safety director",
    	"安全负责人联系电话":"Safety director Phone no.",
    	"安全负责人身份证号":"Safety director ID no.",
    	"施工单位简介":"Introduction to the Contractor",
    	"施工队营业等级":"Business grade of construction team",
    	"施工队负责人":"Construction team person in charge",
    	"施工队负责人联系电话":"Construction team person in charge Phone no.",
    	"施工队负责人身份证号":"Construction team person in charge ID no.",
    	"接待人联系电话":"Receptionist contact number",
    	"责任书签订日期":"Signing date of the letter of responsibility",
    	"责任书到期日期":"Expiry date of the letter of responsibility",
    	"接待人手机号":"Receptionist's mobile number",
    	"所属承包商":"Affiliated Contractor",
    	"对接人":"Counterpart",
    	"社会信用代码":"Social credit code",
    	"施工队负责人身份证":"ID card of the person in charge of the construction team",
    	"安全负责人身份证":"ID card of the person in charge of security",
    	"进厂日期":"Incoming date",
    	"对接人联系方式":"Contact information of counterpart",
    	"公司地址":"Company address",
    	"供应商风险评级":"Supplier Risk Rating",
    	"供应商类别":"Supplier Category",
    	"供应商简介":"Supplier Profile",
    	"员工列表":"Employee List",
    	"访客列表":"Visitor List",
    	"承包商列表":"List of contractors",
    	"承包商作业人员列表":"List of Contractor's operators",
		"柜组":"Cabinet group",
		"人脸机传输状态":"Facial transfer status",
		"人脸机监测时间":"Facial monitoring time",
		"更新时间":"Update time",
		"发卡机详情":"Tag charging station details",
		"有无设备":"Equipment or not",
		"有":"Have",
		"无":"Not have",
		"发卡机监测时间":"Tag charging station monitoring time",
        "发卡机版本号":"Tag charging station version",
		"部门在线率":"Department online rate",
		"实时在线率":"Real time online rate",
		"历史在线率":"Historical online rate",
		"短信日志":"SMS log",
		"接收者":"recipient",
		"短信内容":"SMS content",
		"发送状态":"Send Status",
		"发送时间":"Sending time",
		"回执ID":"Receipt ID",
		"回执信息":"Receipt information",
		"平面坐标工具":"Plane coordinate tool",
		"报警记录":"Alarm record",
		"信标列表":"Beacon list",
		"摄像头列表":"Camera list",
		"车辆列表":"Vehicle list",
		"定位卡列表":"Locating card list",
		"发卡机列表":"Issuer list",
		"发卡机记录列表":"Issuer record list",
		"监控报警记录管理":"Monitoring alarm record management",
		"视频分析设备管理":"Video analysis equipment management",
		"部门列表":"Department List",
		"异常报警记录":"Abnormal alarm record",
		"灯具列表":"List of lamps",
		"楼层列表":"Floor List",
		"楼宇列表":"List of buildings",
		"巡检路线列表":"Patrol route list",
		"隐患管理列表":"Hazard Management List",
		"巡检点列表":"Patrol point list",
		"巡检班组列表":"Patrol inspection team list",
		"岗位列表":"Position List",
		"角色列表":"Role List",
		"JSA分析表":"JSA Analysis Table",
		"基站列表":"Base Station List",
		"车辆统计":"Vehicle statistics",
		"手表列表":"Watch List",
		"鼠标右键绘制电子围栏，需首尾相连":"Right mouse button draw electronic fence, need to end to end",
		"此操作将退出当前登录状态, 是否继续?":"This operation will exit the current login state, whether to continue?",
		"提示":"Prompt",
		"已取消":"Cancelled",
		"本地上传":"Local upload",
		"自动录取":"Automatic admission",
		"上传照片":"Upload photos",
		"导入人员发卡":"Import personnel to issue cards",
		"数据关联列":"Data association column",
		"身份证":"Id card",
		"电子围栏管理":"Electronic fence management",
		"》电子围栏配置":"》Electronic fence configuration",
		"请填写围栏名称":"Please fill in the name of the fence",
		"》报警统计":"》Alarm statistics",
		'成像等级':'Imaging level',
		'人员显示':'People display',
		'透明度':'transparency',
		'拖动开关':'Drag switch',
		'微调开关':'Fine adjustment switch',
		'》大屏展示设置':'》Large screen display settings',
		'起点':'Start Point',
		'此操作将永久删除该信息, 是否继续?':'This operation will permanently delete this information. Do you want to continue?',
		"已取消删除":"Deletion cancelled",
		"失败智能巡检导入结果":"Failed to import intelligent inspection result. Procedure",
		"米":"m",
		"距":"From the",
		"点距离":"Point distance",
		"未知":"Unknown",
		"请输入信标编号":"Please enter the beacon number",
		"移动开关":"Moving switch",
		"测距开关":"Range switch",
		"》信标配置":"》Beacon configuration",
		"鼠标右键添加信标点位":"Right mouse button to add beacon point bit",
		"此操作将永久删除该基站, 是否继续?":"This operation will permanently delete the base station. Do you want to continue?",
		"》基站配置":"》Base station configuration",
		"添加基站":"Base station addition",
		"请输入基站编号":"Please enter the base station number",
		"新增基站":"New base station",
		"此操作将永久删除该楼宇, 是否继续?":"This operation will permanently delete the building. Do you want to continue?",
		"失败人员管理导入结果":"Importing result of failed personnel management",
		"此操作将永久删除该楼层, 是否继续?":"This operation will permanently delete the floor, whether to continue?",
		"请设置该摄像头流地址":"Set the stream address of the camera",
		"》摄像头配置":"》Camera configuration",
		"名称开关":"Name switch",
		"添加摄像头":"Add a camera",
		"此操作将永久删除该摄像头, 是否继续?":"This operation will permanently delete the camera. Do you want to continue?",
		"此操作将永久删除该车辆, 是否继续?":"This operation will permanently delete the vehicle. Do you want to continue?",
		"失败设备管理导入结果":"Failed to import device management. Procedure",
		"此操作将永久删除选中数据, 是否继续?":"This operation will permanently delete the selected data. Do you want to continue?",
		"》楼宇配置":"》Building configuration",
		"导入楼层":"Lead-in floor",
		"二维码边长（cm）":"Qr code side length （cm）",
		"建议扫码距离（米）":"Recommended code sweep distance （m）",
		"下载":"download",
		"一键销警":"One button off alarm",
		"位置追踪":"Position tracking",
		"司机电话":"Driver telephone",
		"当前时速":"Current speed",
		"设备电量":"Equipment power",
		"此操作将永久删除该定位卡, 是否继续?":"This operation will permanently delete the location card. Do you want to continue?",
		"离职日期":"Date of departure",
		"返岗":"Return to post",
		"返岗日期":"Return date",
		"返岗日期不能为空":"The return date cannot be empty",
		"离职日期不能为空":"The termination date cannot be empty",
		"定位":"positioning",
		"重新绘制":"redraw",
		"参考坐标":"Reference coordinate",
		"校准坐标（拖动校准）":"Calibration coordinates (drag calibration)",
		"最大经纬度":"Maximum latitude and longitude",
		"最小经纬度":"Minimum latitude and longitude",
		"计算":"calculation",
		"完成":"complete",
		"坐标系":"Coordinate system",
		"请输入经度":"Please enter the longitude",
		"请输入纬度":"Please enter the latitude",
		"限速(Km/h)":"Speed limit (Km/h)",
		"发卡机SN码":"Card issuer SN code",
		"请选择地图":"Please select map",
		"添加点位":"Add point bit",
		"此操作将永久删除该围栏, 是否继续?":"This operation will permanently delete the fence. Do you want to continue?",
		"报警规则(秒/人)":"Alarm rules (seconds/person)",
		"人员选择":"Personnel selection",
		"已选人员":"Selected personnel",
		"选择报警部门":"Select alarm department",
		"更多人员请搜索姓名":"More people please search by name",
		"人员报警通知":"Personnel alarm notification",
		"车辆报警通知":"Vehicle alarm notice",
		"巡检异常通知":"Inspection exception notification",
		"报警视频联动":"Alarm video linkage",
		"车辆管理":"Vehicle management",
		"车辆选择":"Vehicle selection",
		"请选择绑定状态":"Please select the binding state",
		"是否绑定":"Bind or not",
		"此操作将永久删除, 是否继续?":"This operation will be permanently deleted. Do you want to continue?",
		"此操作将永久删除该报警通知设置, 是否继续?":"This action will permanently delete this alarm notification setting, whether to continue?",
		"请填写单区名称":"Please fill in the list area name",
		"此操作将永久删除该文件, 是否继续?":"This operation will delete the file permanently. Do you want to continue?",
		"》新增单区列表":"》Added the single area list",
		"编辑区域":"Edit area",
		"风险分区管理":"Risk zoning management",
		"》风险分区配置":"》Risk zone configuration",
		"查看区域":"View area",
		"分区颜色":"Partition color",
		"红色":"Red",
		"橙色":"Orange",
		"黄色":"Yellow",
		"蓝色":"Blue",
		"编辑信标分组":"Edit the beacon group",
		"》二道门进出记录":"》Two door access record",
		"上班":"Go to work",
		"下班":"after work",
		"》考勤记录":"》Arecordttendance",
		"请输入在线率":"Please enter online rate",
		"部门人数":"Department head count",
		"在线率":"On-line rate",
		"此操作将永久删除记录, 是否继续?":"This operation will permanently delete the record, whether to continue?",
		"集合时间":"Gathering time",
		"存在问题":"Have a problem",
		"未到达":"Not arrived",
		"已到达":"Have arrived",
		"此操作将永久删除该菜单, 是否继续?":"This operation will permanently delete the menu. Do you want to continue?",
		"我的":"mine",
		"此操作将永久删除该角色, 是否继续?":"This operation will permanently delete the role. Do you want to continue?",
		"此操作将永久删除该用户, 是否继续?":"This operation will permanently delete the user. Do you want to continue?",
		"只能选择一名巡检负责人":"Only one inspection leader can be selected",
		"确定要解绑人员吗？":"Are you sure you want to unshackle them?",
		"详情":"details",
		"轨迹":"track",
		"年":"years",
		"月":"month",
		"日":"day",
		"倍数":"multiple",
		"请选择人员":"Please select personnel",
		"未查询到相关数据":"No data is queried",
		"此操作将永久删除该部门, 是否继续?":"This operation will permanently delete the department. Do you want to continue?",
		"此操作将永久删除该岗位, 是否继续?":"This operation will permanently delete the post, do you want to continue?",
		"添加下属部门":"Add a subordinate department",
		"编辑部门信息":"Edit department information",
		"删除部门":"Delete department",
		"星图":"GEOVIS",
		"请绘制围栏！":"Please draw the fence!",
		"此操作将永久删除该分区, 是否继续?":"This operation will permanently delete the partition. Do you want to continue?",
		"同步中":"In sync",
		"复制成功":"Successful replication",
		"复制失败，请手动复制":"Replication failed, please manually copy",
		"等":"Etc",
		"在":"in",
		"处":"place",
		"请及时处理":"Please deal with it in time",
		"无定位处":"There is no definite position",
		"触发":"trigger",
		"添加楼宇":"Addition of building"
	},
	'单位':{
		'人':'',
		'/人':'',
		'次':'',
		'个':''
	}
}


// WEBPACK FOOTER //
// ./src/i18n/lang/en.js